module.exports = __webpack_public_path__ + "img/ys-four-grid.050365b7.png";